import { FETCH_USERS } from '../actions/UserActions';

// INITIALIZE STATE
const initialState = {
    users: null,
    fetching: false,
    fetched: false,
    failed: false,
    paging: {
        total: 0,
        pageNumber: 1,
        pageSize: 5,
        pages: 1,
    },
};

// REDUCER
export const UsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_USERS}_PENDING`:
            return {
                ...state,
                users: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_USERS}_FULFILLED`:
            return {
                ...state,
                users: action.payload.data,
                paging: action.payload.paging,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_USERS}_REJECTED`:
            return {
                ...state,
                users: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
